import React, { useState, useMemo, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Typography,
  Paper,
  IconButton,
  Chip,
  Divider,
  Grid,
  Card,
  CardContent,
  Stack,
  CircularProgress,
   Table ,
    TableBody ,
    TableRow ,
    TableCell ,
    TableHead 
    
} from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent
  
} from "@mui/lab";
import {
  Close,
  LocalHospital,
} from "@mui/icons-material";
import { getPatientTimeline_ScanHistoryAdmission  ,getPatientVisitDetailsScan} from "../BaseURL";
import axios from "axios";
import moment from "moment";

const ScanHistoryDialogAdmission = ({ open, onClose, patientData ,sendstartDate }) => {
    
 const currentDate = moment().format('YYYY-MM-DD')

  const [medicalEvents, setMedicalEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventDetails, setEventDetails] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);

  // Filtering Logic - added safety check
  const filteredEvents = useMemo(() => {
    if (!medicalEvents || !Array.isArray(medicalEvents)) {
      return [];
    }
    
    return medicalEvents.filter((ev) => {
      const matchesSearch =
        (ev.title || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (ev.type || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (ev.doctor || "").toLowerCase().includes(searchTerm.toLowerCase());

      const date = new Date(ev.date);
      const afterStart = startDate ? date >= new Date(startDate) : true;
      const beforeEnd = endDate ? date <= new Date(endDate) : true;

      return matchesSearch && afterStart && beforeEnd;
    });
  }, [searchTerm, startDate, endDate, medicalEvents]);

  // Load timeline list
  const loadTimeline = async () => {
    if (!patientData) return;

    try {
      const response = await axios.get(getPatientTimeline_ScanHistoryAdmission, {
        params: { patientId: patientData.id , startDate:sendstartDate  ,enddate:currentDate}
      });

      if (response.data.success) {
        setMedicalEvents(response.data.events || []);
        console.log(response.data.events);
      }
    } catch (error) {
      console.error("Error loading timeline:", error);
      setMedicalEvents([]); // Set empty array on error
    }
  };

  // Load visit details when timeline item is clicked
  const loadVisitDetails = async (event) => {
   
    setSelectedEvent(event);
    setLoadingDetails(true);
    setEventDetails(null);

    try {
      const response = await axios.get(getPatientVisitDetailsScan, {
        params: { 
          patientId: patientData.id,
          visitDate: event.date
        }
      });

      if (response.data.success) {
        setEventDetails(response.data.details);
      }
    } catch (error) {
      console.error("Error loading visit details:", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  useEffect(() => {
    if (open && patientData) {
      loadTimeline();
    }
  }, [open, patientData]);

  // Reset state when dialog closes
  useEffect(() => {
    if (!open) {
      setSelectedEvent(null);
      setEventDetails(null);
      setSearchTerm("");
      setStartDate("");
      setEndDate("");
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          height: "90vh",
          maxHeight: "90vh"
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "primary.main",
          color: "white",
          py: 2
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight="bold">
            Scan History
          </Typography>
          {patientData && (
            <Typography variant="subtitle2">
              {patientData.fullName} - {patientData.id}
            </Typography>
          )}
        </Box>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent 
        sx={{ 
          p: 0, 
          display: "flex", 
          height: "100%",
          flexDirection: { xs: "column", md: "row" }
        }}
      >

        {/* LEFT SIDE - Timeline */}
        <Box
          sx={{
            width: { xs: "100%", md: "40%" },
            background: "linear-gradient(135deg, #3b854fff 0%, #3ba55d 100%)",
            color: "white",
            overflowY: "auto",
            p: 3,
            maxHeight: { xs: "40vh", md: "100%" }
          }}
        >
          {/* Search + Date Filters */}
          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Search Scan..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                mb: 2,
                "& .MuiInputBase-root": {
                  backgroundColor: 'background.paper',
                  borderRadius: 1
                }
              }}
            />

            <Grid container spacing={1} columns={{ xs: 4, sm: 8, md: 12 }}>
              <Grid item xs={6} size={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="Start Date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  sx={{
                    "& .MuiInputBase-root": {
                      backgroundColor: 'background.paper',
                      borderRadius: 1
                    }
                  }}
                />
              </Grid>
              <Grid item xs={6} size={6}>
                <TextField
                  fullWidth
                  type="date"
                  label="End Date"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  sx={{
                    "& .MuiInputBase-root": {
                      backgroundColor: 'background.paper',
                      borderRadius: 1
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Timeline */}
          <Timeline position="right">
            {filteredEvents.length === 0 ? (
              <Typography sx={{ textAlign: "center", mt: 5, opacity: 0.8 }}>
                No Scan records found.
              </Typography>
            ) : (
              filteredEvents.map((event, index) => (
                <TimelineItem key={index}>
                  <TimelineOppositeContent sx={{ m: "auto 0", flex: 0.3 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                      {event.date}
                    </Typography>
                  </TimelineOppositeContent>

                  <TimelineSeparator>
                    <TimelineConnector
                      sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
                    />
                    <TimelineDot color={event.color || "primary"}>
                      <LocalHospital />
                    </TimelineDot>
                    <TimelineConnector
                      sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
                    />
                  </TimelineSeparator>

                  <TimelineContent sx={{ py: 2, px: 2 }}>
                    <Paper
                      elevation={
                        selectedEvent?.date === event.date ? 12 : 4
                      }
                      onClick={() => loadVisitDetails(event)}
                      sx={{
                        p: 2,
                        cursor: "pointer",
                        borderRadius: 2,
                        backgroundColor:
                          selectedEvent?.date === event.date
                            ? "rgba(255,255,255,1)"
                            : "rgba(255,255,255,0.9)",
                        border:
                          selectedEvent?.date === event.date
                            ? "3px solid #667eea"
                            : "2px solid transparent",
                        transition: "0.25s",
                        "&:hover": { transform: "translateY(-4px)" }
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        color="primary"
                      >
                        {event.title}
                      </Typography>
                      <Chip
                        label={event.type}
                        size="small"
                        sx={{ mt: 1, fontSize: "0.7rem" }}
                      />
                     <Box 
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 1, 
                            mt: 1.5,
                            p: 1,
                            borderRadius: 1,
                            bgcolor: 'action.hover'
                        }}
                        >
                        <Box
                            sx={{
                            width: 24,
                            height: 24,
                            borderRadius: '50%',
                            bgcolor: '#06b6d420',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '0.75rem'
                            }}
                        >
                            🔬
                        </Box>
                        <Typography
                            variant="caption"
                            sx={{
                            color: 'text.secondary',
                            fontWeight: 500
                            }}
                        >
                            Scan Technician:
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                            color: '#06b6d4',
                            fontWeight: 600
                            }}
                        >
                            {event.doctor}
                        </Typography>
                        </Box>
                    </Paper>
                  </TimelineContent>
                </TimelineItem>
              ))
            )}
          </Timeline>
        </Box>

        {/* RIGHT SIDE - Detailed View */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            p: 4,
            backgroundColor: 'background.default',
            maxHeight: { xs: "60vh", md: "100%" }
          }}
        >
          {loadingDetails ? (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <CircularProgress />
            </Box>
          ) : eventDetails ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3
                }}
              >
                <Box>
                  <Typography variant="h4" fontWeight={600} gutterBottom>
                    {selectedEvent.title}
                  </Typography>
                  <Typography variant="h6" color="text.secondary">
                    {selectedEvent.date}
                  </Typography>
                </Box>
                <Chip
                 label={selectedEvent.type}
                  color={eventDetails.color || "primary"}
                  sx={{ fontSize: "1rem", py: 2.5, px: 1 }}
                />
              </Box>

              <Divider sx={{ mb: 3 }} />

               {eventDetails.scan && Object.keys(eventDetails.scan).length > 0 && (
                          <Card sx={{ mb: 3, boxShadow: 2 }}>
                            <CardContent>
                              <Typography variant="h6" fontWeight={600} gutterBottom>
                                Scan Results
                              </Typography>
              
                              {Object.entries(eventDetails.scan).map(([scanType, items]) => (
                                <Box key={scanType} sx={{ mb: 4 }}>
                                  <Typography
                                    variant="subtitle1"
                                    fontWeight={700}
                                    sx={{ mb: 1, color: "primary.main" }}
                                  >
                                    {scanType}
                                  </Typography>
              
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow sx={{ backgroundColor: 'background.default' }}>
                                        <TableCell sx={{ fontWeight: 700 }}>Parameter</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }}>Findings</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }}>Flag</TableCell>
                                        <TableCell sx={{ fontWeight: 700 }}>Comments</TableCell>
                                      </TableRow>
                                    </TableHead>
              
                                    <TableBody>
                                      {items.map((row, idx) => (
                                        <TableRow key={idx}>
                                          <TableCell sx={{ fontWeight: 600, width: "20%" }}>
                                            {row.para}
                                          </TableCell>
              
                                          <TableCell sx={{ width: "55%" }}>
                                            {row.finding}
                                          </TableCell>
              
                                          <TableCell
                                            sx={{
                                              width: "10%",
                                              fontWeight: 700,
                                              color:
                                                row.flag === "ABNORMAL"
                                                  ? "red"
                                                  : row.flag
                                                  ? "orange"
                                                  : "text.secondary"
                                            }}
                                          >
                                            {row.flag || ""}
                                          </TableCell>
              
                                          <TableCell sx={{ width: "15%" }}>
                                            —
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
              
                                  <Typography
                                    variant="caption"
                                    sx={{ display: "block", mt: 1, opacity: 0.8 }}
                                  >
                                    Technician: {items[0].technician || "—"} | Date: {items[0].date}
                                  </Typography>
                                </Box>
                              ))}
                            </CardContent>
                          </Card>
                          )}

            
              {/* Attending Physician */}
              <Card 
                sx={{ 
                boxShadow: 2,
                border: '1px solid',
                borderColor: 'divider',
                '&:hover': {
                    boxShadow: 4,
                    borderColor: '#06b6d4',
                    transition: 'all 0.3s ease'
                }
                }}
            >
            <CardContent sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                <Box
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 2,
                    bgcolor: '#06b6d415',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem'
                }}
                >
                👨‍⚕️
                </Box>
                <Typography 
                variant="h6" 
                fontWeight={600}
                sx={{ color: 'text.primary' }}
                >
                Attending Technician
                </Typography>
            </Box>
            
            <Typography 
                variant="body1"
                sx={{ 
                color: '#06b6d4',
                fontWeight: 500,
                pl: 7,
                fontSize: '1.1rem'
                }}
            >
                {selectedEvent.doctor}
            </Typography>
            </CardContent>
              </Card>
            </>
          ) : (
            <Typography variant="h5" color="text.secondary" sx={{ textAlign: "center", mt: 10 }}>
              Select a visit from the timeline to view details.
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, bgcolor: 'background.default' }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
        <Button variant="contained" color="primary">
          Print History
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScanHistoryDialogAdmission;

